import React, { useContext, useState, useCallback, memo } from 'react'
import styled from 'styled-components'
import { Text, Node, Path } from 'vendor/slate'
import { useSlate, ReactEditor } from 'vendor/slate-react'

const CodeTabsContentLineItem = memo(({ refractor, attributes, children, element, editor }) => {
  const parent = ReactEditor.findParent(editor, element)
  const { language } = parent || {}

  const getLength = token => {
    const { type, value, children } = token

    if (type === 'text') {
      return value.length
    }
    if (type === 'element') {
      return children.reduce((l, t) => l + getLength(t), 0)
    }
    return 0
  }

  const decorate = useCallback(
    ([node, path]) => {
      const ranges = []

      if (!Text.isText(node)) {
        return ranges
      }

      const tokens =
        !language || !refractor
          ? []
          : language !== 'plaintext'
            ? refractor?.registered(language)
              ? refractor.highlight(node.text, language)
              : []
            : []

      let start = 0
      for (const token of tokens) {
        const { type, properties, value } = token
        const length = getLength(token)
        const end = start + length

        if (type === 'element') {
          ranges.push({
            className: properties ? properties.className.join(' ') : null,
            anchor: { path, offset: start },
            focus: { path, offset: end }
          })
        }

        start = end
      }

      return ranges
    },
    [language, refractor]
  )

  return (
    <CodeTabContentLineItem {...attributes}>
      {React.Children.map(children, child => React.cloneElement(child, { decorate }))}
    </CodeTabContentLineItem>
  )
})

export default CodeTabsContentLineItem

const CodeTabContentLineItem = styled.div`
  position: relative;
  overflow-wrap: normal;
  white-space: pre;
  counter-increment: line 1;
  line-height: 1.45em;
  font-size: 13.5px;
  padding: 0px 0px 0px 44px;
  &:not(:only-child)::before {
    top: 1px;
    left: 4px;
    color: ${props => props.theme.textGreyTintedLighter};
    opacity: 0.7;
    width: 24px;
    bottom: 0px;
    content: counter(line);
    display: inline-block;
    position: absolute;
    font-size: 13.75px;
    text-align: right;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
    background-color: transparent;
    user-select: none;
    overflow: hidden;
  }
`
